// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZDXB0","rootMobile":"styles_rootMobile__3aVfp"};